export const getSource = () => {
  const url = new URL(window.location.href);

  return url.searchParams.get("s");
};

export const getSourceFromConfig = (loginUrl: string) => {
  const url = new URL(loginUrl);

  return url.searchParams.get("source");
};
